<h1>MAILING LIST</h1>
<div class="toptext">
	<h2>Agora</h2>
	<p>
		Nato dall'idea greca di ἀγορά (assemblea, raduno), la mailing list <b>De Cifris Agora</b>
		permette ai soci di proporre liberamente i propri seminari alla comunità. <!--Visita la <a
		[routerLink]="[ '/deCifrisAgora']">pagina web di Agora</a>.-->
		<br>
		Indirizzo: <a href="mailto:agora@decifris.it">agora&#64;decifris.it</a>.
	</p>
</div>

<div class="text">
	<h2>Altre</h2>
	<p>
		Gestivamo molte mailing list specializzate e associate alla sezione seminari che saranno riattivate in futuro:
	</p>
	<ul>
		<li>
			<b>Eruditorum</b>, annunci di seminari su temi di ampia portata e
			cultura generale, come ad esempio la Storia della crittografia,
			l’interazione della crittografia con la Società, gli aspetti Legali e
			Giuridici, etc.
		</li>
		<li>
			<b>Historiae</b>, annunci di seminari inerenti la storia della
			crittografia.
		</li>
		<li>
			<b>Athesis</b>, annunci sui seminari che teniamo a Trento, circa uno al mese
		</li>
		<li>
			<b>Taurinorum</b>, annunci sui seminari che teniamo a Torino, circa uno al mese
		</li>
		<li>
			<b>Latina</b>, annunci sui seminari che teniamo a Roma, circa uno al mese
		</li>
		<li>
			<b>Mediolanensibus</b>, annunci sui seminari che teniamo a Milano, circa uno al mese
		</li>
		<li>
			<b>Cifris Chain</b>, annunci su eventi e progetti specifici per
			Cifris Chain (il nostro team interno che lavora su blockchain)
		</li>
		<li>
			<b>PQCifris</b>, annunci su eventi e progetti specifici per
			PQCifris (il nostro team interno che lavora su cifrari post-quantum)
		</li>
		<li>
			<b>QuantumCifris</b>, annunci su eventi e progetti specifici per
			QuantumCifris (il nostro team interno che lavora su Quantum
			Cryptography)
		</li>
		<li>
			<b>CloudCifris</b>, annunci su eventi e progetti specifici per
			CloudCifris (il nostro team interno che lavora sui cifrari per il
			Cloud Computing)
		</li>
		<li>
			<b>Math Cifris</b>, annunci sul gruppo specificatamente matematico
			che stiamo costituendo in collaborazione con l'UMI (Unione
			Matematica Italiana)
		</li>
	</ul>

	<p>
		Se condividi i nostri interessi, associati!
		<br>
		L'associazione ti dà diritto a registrarti a tutte le nostre mailing-list che ti interessano.
		Le mailing-list sono puramente informative e potrai cancellarti in qualunque momento da
		qualunque mailing list di tua scelta.
		<br>
		<a routerLink="/associarsi">Per associarti basta seguire queste semplici istruzioni</a>.
	</p>
</div>